export const PRE_START_RESPONSE_TYPES_V3 = [
  {
    label: "Yes / No",
    value: "yes_no",
    response_config: {
      schemaVersion: 1,
      type: "radio",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" }
      ],
      flagOnValue: null
    }
  },
  {
    label: "Yes / No / N/A",
    value: "yes_no_na",
    response_config: {
      schemaVersion: 1,
      type: "radio",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
        { value: "not_applicable", label: "N/A" }
      ],
      flagOnValue: null
    }
  },
  {
    label: "Pass / Fail",
    value: "pass_fail",
    response_config: {
      schemaVersion: 1,
      type: "radio",
      options: [
        { value: "pass", label: "Pass" },
        { value: "fail", label: "Fail" }
      ],
      flagOnValue: null
    }
  },
  {
    label: "Free text",
    value: "text",
    response_config: {
      schemaVersion: 1,
      type: "text",
      multiline: true
    }
  },
  {
    label: "Number",
    value: "number",
    response_config: {
      schemaVersion: 1,
      type: "number",
      unit: null
    }
  },
  {
    label: "Signature",
    value: "signature",
    response_config: {
      schemaVersion: 1,
      type: "signature"
    }
  },
  {
    label: "Photo capture",
    value: "photo",
    response_config: {
      schemaVersion: 1,
      type: "photo"
    }
  }
];

const cloneData = (data) => JSON.parse(JSON.stringify(data));

export const getResponseTypeOptionV3 = (value) => {
  return PRE_START_RESPONSE_TYPES_V3.find((option) => option.value === value) || null;
};

export const cloneResponseConfigByTypeV3 = (value) => {
  const option = getResponseTypeOptionV3(value);
  return option ? cloneData(option.response_config) : null;
};

export const responseConfigToResponseTypeValueV3 = (responseConfig = {}) => {
  if (!responseConfig || typeof responseConfig !== "object") {
    return "";
  }

  if (responseConfig.type === "radio") {
    const signature = Array.isArray(responseConfig.options)
      ? responseConfig.options.map((option) => option && option.value).join(",")
      : "";

    if (signature === "yes,no") {
      return "yes_no";
    }

    if (signature === "yes,no,not_applicable") {
      return "yes_no_na";
    }

    if (signature === "pass,fail") {
      return "pass_fail";
    }

    return "";
  }

  if (["text", "number", "signature", "photo"].includes(responseConfig.type)) {
    return responseConfig.type;
  }

  return "";
};

export const sanitizeResponseConfigForTypeV3 = (responseTypeValue, workingConfig = {}) => {
  const baseConfig = cloneResponseConfigByTypeV3(responseTypeValue);
  if (!baseConfig) {
    return {};
  }

  if (baseConfig.type === "radio") {
    const optionValues = Array.isArray(baseConfig.options)
      ? baseConfig.options.map((option) => option && option.value).filter(Boolean)
      : [];
    const selectedFlag = workingConfig && workingConfig.flagOnValue;

    return {
      ...baseConfig,
      flagOnValue: optionValues.includes(selectedFlag) ? selectedFlag : null
    };
  }

  if (baseConfig.type === "number") {
    const resolvedUnit = workingConfig && Object.prototype.hasOwnProperty.call(workingConfig, "unit")
      ? workingConfig.unit
      : baseConfig.unit;

    return {
      ...baseConfig,
      unit: resolvedUnit == null ? null : `${resolvedUnit}`
    };
  }

  return baseConfig;
};

export const getFlagOptionsV3 = (responseTypeValue) => {
  const config = cloneResponseConfigByTypeV3(responseTypeValue);
  if (!config || config.type !== "radio" || !Array.isArray(config.options)) {
    return [];
  }

  return config.options;
};
